(() => {
  if (window.dtcMagnifyHoverInitialized) return;
  window.dtcMagnifyHoverInitialized = true;

  const zoomRatio = 2;
  let activeImage = null;
  let activeOpener = null;
  let activeOverlay = null;

  function createOverlay(image) {
    const overlay = document.createElement('div');
    overlay.className = 'image-magnify-full-size';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.style.backgroundImage = `url('${image.currentSrc || image.src}')`;
    overlay.style.backgroundColor = 'var(--gradient-background)';
    image.parentElement.insertBefore(overlay, image);
    return overlay;
  }

  function moveWithPointer(image, event, overlay) {
    const bounds = image.getBoundingClientRect();
    const x = Math.min(Math.max(event.clientX - bounds.left, 0), bounds.width);
    const y = Math.min(Math.max(event.clientY - bounds.top, 0), bounds.height);

    overlay.style.backgroundPosition = `${(x / bounds.width) * 100}% ${(y / bounds.height) * 100}%`;
    overlay.style.backgroundSize = `${image.clientWidth * zoomRatio}px auto`;
  }

  function removeOverlay() {
    activeOverlay?.remove();
    activeImage = null;
    activeOpener = null;
    activeOverlay = null;
  }

  function getHoverMedia(target) {
    if (!(target instanceof Element)) return null;

    const opener = target.closest('.product__modal-opener--image');
    const image = opener?.querySelector('.image-magnify-hover');
    return image ? { image, opener } : null;
  }

  document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse') return;

    const media = getHoverMedia(event.target);
    if (!media || media.opener === activeOpener) return;

    removeOverlay();
    activeImage = media.image;
    activeOpener = media.opener;
    activeOverlay = createOverlay(activeImage);
    moveWithPointer(activeImage, event, activeOverlay);
  });

  document.addEventListener('pointermove', (event) => {
    if (event.pointerType !== 'mouse' || !activeImage || !activeOverlay) return;
    moveWithPointer(activeImage, event, activeOverlay);
  });

  document.addEventListener('pointerout', (event) => {
    if (
      event.pointerType === 'mouse' &&
      activeOpener &&
      (!event.relatedTarget || !activeOpener.contains(event.relatedTarget))
    ) {
      removeOverlay();
    }
  });
})();
